// extracted by mini-css-extract-plugin
export default {"filter-by-date-form":"styles_filter-by-date-form__1lI7Y"};